import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/icon/oem-tip.png'


const _withScopeId = n => (_pushScopeId("data-v-1f46ec3c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tip" }
const _hoisted_2 = { class: "tip-title ft-w-6 flex-ter" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  referrerPolicy: "no-referrer",
  src: _imports_0,
  class: "icon mr_10"
}, null, -1))
const _hoisted_4 = { class: "flex-col" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = ["src"]
const _hoisted_8 = { key: 2 }


import { t } from '@/plugins/i18n'

export default /*#__PURE__*/_defineComponent({
  props: ['tooltip', 'tipOption'],
  setup(__props) {

const props = __props


const option = { title: '说明', ...props.tipOption }


return (_ctx: any,_cache: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (__props.tooltip || __props.tipOption)
    ? (_openBlock(), _createBlock(_component_el_tooltip, {
        key: 0,
        effect: "light",
        "hide-after": 40,
        "show-after": 100,
        placement: "right-start",
        "show-arrow": false,
        "popper-class": option.className,
        "popper-options": option.popper
      }, {
        content: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createTextVNode(" " + _toDisplayString(_unref(t)(option.title)), 1)
            ]),
            _createElementVNode("div", _hoisted_4, [
              (__props.tooltip&&_unref(t)(__props.tooltip))
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    (_unref(t)(__props.tooltip).split('\n').length>1)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          innerHTML: _unref(t)(__props.tooltip).replace(/\n/g,'<br/>')
                        }, null, 8, _hoisted_6))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString(_unref(t)(__props.tooltip)), 1)
                        ], 64))
                  ]))
                : _createCommentVNode("", true),
              (option.img)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    referrerPolicy: "no-referrer",
                    class: "pic mt_5 mb_5",
                    src: option.img
                  }, null, 8, _hoisted_7))
                : _createCommentVNode("", true),
              (option.textJP)
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(option.textJP), 1))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["popper-class", "popper-options"]))
    : _renderSlot(_ctx.$slots, "default", { key: 1 })
}
}

})